import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "pt-2"
}

import getOfficesResponse from "@/types/responses/getOffices"
import getOfficesType from "@/types/responses/getOffices";
import { Ref, onMounted, ref, computed, watch } from 'vue';
import Api from "@/services/api/ApiServiceFabrick";
import i18n from '@/lang/i18n';

type officeType = {
  id: number | null,
  type: string,
  name: string | undefined,
  departments: getOfficesType['departments']
}


export default /*@__PURE__*/_defineComponent({
  __name: 'OrganizationAutoComplete',
  props: {
    modelValue: {},
    selectedOfficeableType: {},
    errorMessages: {},
    readonly: { type: Boolean, default: false },
    clearable: { type: Boolean, default: true },
    label: { default: i18n.global.t('pages.common.filter.organization') }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;
const props = __props

const items: Ref<officeType[]> = ref([])

onMounted(() => {
  Api().getOffices().then((data: getOfficesResponse[]) => {
    data.forEach((office: getOfficesResponse) => {
      items.value.push({
        id: office.id,
        type: office.type.split('\\')[2],
        name: office.company_name ?? office.operation_office_name,
        departments: office.departments ?? []
      })
    })
  })
})

const modelValue = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit("update:modelValue", value);
  },
})

const selectableItems = computed(() => {
  if (!props.selectedOfficeableType.type) {
    return items.value
  }
  return items.value.filter((item) => {
    return item.type === props.selectedOfficeableType.type
  })
})

const hasSingleSelectableItem = computed(() => {
  return selectableItems.value.length === 1;
})

watch(selectableItems, (newItems) => {
  if (newItems.length === 1) {
    modelValue.value = newItems[0];
  }
})

return (_ctx: any,_cache: any) => {
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!

  return (hasSingleSelectableItem.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(modelValue.value?.name), 1))
    : (_openBlock(), _createBlock(_component_v_autocomplete, _mergeProps({
        key: 1,
        label: __props.label,
        modelValue: modelValue.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event)),
        items: selectableItems.value,
        "item-title": "name",
        "item-value": "name"
      }, { 'return-object': true }, {
        readonly: props.readonly,
        "error-messages": props.errorMessages,
        clearable: props.clearable
      }), null, 16, ["label", "modelValue", "items", "readonly", "error-messages", "clearable"]))
}
}

})